/**
 * A signed in device in words, from the browser string the server kept: `Chrome on macOS`.
 * Anything it does not recognise is shown as it came, cut short, never as an empty line.
 */
export function deviceName(raw: string | null | undefined): string | null {
  if (raw === null || raw === undefined || raw.trim() === '') return null;
  const browser = /Edg\//.test(raw)
    ? 'Edge'
    : /OPR\/|Opera/.test(raw)
      ? 'Opera'
      : /SamsungBrowser/.test(raw)
        ? 'Samsung Internet'
        : /Firefox\//.test(raw)
          ? 'Firefox'
          : /Chrome\/|CriOS/.test(raw)
            ? 'Chrome'
            : /Safari\//.test(raw)
              ? 'Safari'
              : null;
  const system = /Android/.test(raw)
    ? 'Android'
    : /iPhone|iPad|iPod/.test(raw)
      ? 'iOS'
      : /Windows/.test(raw)
        ? 'Windows'
        : /Mac OS X|Macintosh/.test(raw)
          ? 'macOS'
          : /Linux/.test(raw)
            ? 'Linux'
            : null;
  if (browser !== null && system !== null) return `${browser} on ${system}`;
  if (browser !== null) return browser;
  if (system !== null) return system;
  return raw.length > 40 ? `${raw.slice(0, 40)}...` : raw;
}
